(ns app.front.view.escrow.files
  (:require [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.subs :as gas]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::attach-file-to-account
  (fn [_ [_ {:keys [account-id
                    file-id
                    filename
                    file-mime-type
                    md5-base64]}]]
    {:comm/command {:command    :fee.escrow/add-escrow-account-attachment
                    :method     :post
                    :data       (util/mmap {:file/md5          md5-base64
                                            :file/content-type file-mime-type
                                            :file/filename     filename}
                                           account-id file-id)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::remove-attachment
  (fn [_ [_ file-id]]
    {:comm/command {:command    :fee.escrow/remove-attachment
                    :method     :post
                    :data       (util/mmap file-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :escrow.management/attachment-delete-success}}}))

(defn account-files-widget [{:keys [tr account-id has-write-access?]}]
  (let [tz (<sub [::gas/group-tz])]
    [:div
     (when has-write-access?
       [upload/upload-area
        (str "upload-account-file-" account-id)
        {:attach-file-v2-fn   (fn [{:keys [file-id filename file-mime-type md5-base64]}]
                                (>evt [::attach-file-to-account (util/mmap account-id
                                                                           file-id
                                                                           filename
                                                                           file-mime-type
                                                                           md5-base64)]))
         :accept-types        []
         :additional-help     (tr [:escrow.management/add-file-help])
         :select-directories? false}])
     [ui-table/modern-responsive-table
      {:cols         [[:file/filename
                       (fn [file]
                         (file-download/download-file-link file
                                                           {:command :fee.escrow/download-attachment}))]
                      [(tr [:escrow.management/file-uploaded])
                       (fn [file]
                         (-> file :entity/created (date-util/date-time-in-tz tz)))]
                      [(tr [:escrow.management/file-uploaded-by])
                       (fn [file]
                         (-> file :entity/creator user-model/full-name))]]
       :items        (<sub [::entities/entities {:entity/type   :entity.type/file
                                                 :entity/parent account-id}])
       :tr           tr
       :make-actions (when has-write-access?
                       (fn [file]
                         [{:title    (tr [:escrow.management/delete-file])
                           :data-cy  "delete-file"
                           :icon     i/trash
                           :confirm? true
                           :on-click #(>evt [::remove-attachment (:db/id file)])}]))}]]))
